/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OptimizeTransportLotRequestTodayStockListInner } from './OptimizeTransportLotRequestTodayStockListInner';
import {
    OptimizeTransportLotRequestTodayStockListInnerFromJSON,
    OptimizeTransportLotRequestTodayStockListInnerFromJSONTyped,
    OptimizeTransportLotRequestTodayStockListInnerToJSON,
} from './OptimizeTransportLotRequestTodayStockListInner';
import type { TransportLotInput } from './TransportLotInput';
import {
    TransportLotInputFromJSON,
    TransportLotInputFromJSONTyped,
    TransportLotInputToJSON,
} from './TransportLotInput';

/**
 * 
 * @export
 * @interface OptimizeTransportLotRequest
 */
export interface OptimizeTransportLotRequest {
    /**
     * 最適化の方向（前倒し/後倒し）
     * @type {string}
     * @memberof OptimizeTransportLotRequest
     */
    logic: OptimizeTransportLotRequestLogicEnum;
    /**
     * 固定積載率（％）
     * @type {number}
     * @memberof OptimizeTransportLotRequest
     */
    fixLoadCapacity: number;
    /**
     * 最小積載率（％）
     * @type {number}
     * @memberof OptimizeTransportLotRequest
     */
    minLoadCapacity: number;
    /**
     * 最小発注量
     * @type {number}
     * @memberof OptimizeTransportLotRequest
     */
    minOrderQuantityOnce: number;
    /**
     * 
     * @type {Array<TransportLotInput>}
     * @memberof OptimizeTransportLotRequest
     */
    todayTransportLotList: Array<TransportLotInput>;
    /**
     * 
     * @type {Array<TransportLotInput>}
     * @memberof OptimizeTransportLotRequest
     */
    nextdayTransportLotList: Array<TransportLotInput>;
    /**
     * 
     * @type {Array<OptimizeTransportLotRequestTodayStockListInner>}
     * @memberof OptimizeTransportLotRequest
     */
    todayStockList: Array<OptimizeTransportLotRequestTodayStockListInner>;
    /**
     * 
     * @type {Array<OptimizeTransportLotRequestTodayStockListInner>}
     * @memberof OptimizeTransportLotRequest
     */
    nextdayStockList: Array<OptimizeTransportLotRequestTodayStockListInner>;
}


/**
 * @export
 */
export const OptimizeTransportLotRequestLogicEnum = {
    Forward: 'forward',
    Backward: 'backward'
} as const;
export type OptimizeTransportLotRequestLogicEnum = typeof OptimizeTransportLotRequestLogicEnum[keyof typeof OptimizeTransportLotRequestLogicEnum];


/**
 * Check if a given object implements the OptimizeTransportLotRequest interface.
 */
export function instanceOfOptimizeTransportLotRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "logic" in value;
    isInstance = isInstance && "fixLoadCapacity" in value;
    isInstance = isInstance && "minLoadCapacity" in value;
    isInstance = isInstance && "minOrderQuantityOnce" in value;
    isInstance = isInstance && "todayTransportLotList" in value;
    isInstance = isInstance && "nextdayTransportLotList" in value;
    isInstance = isInstance && "todayStockList" in value;
    isInstance = isInstance && "nextdayStockList" in value;

    return isInstance;
}

export function OptimizeTransportLotRequestFromJSON(json: any): OptimizeTransportLotRequest {
    return OptimizeTransportLotRequestFromJSONTyped(json, false);
}

export function OptimizeTransportLotRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizeTransportLotRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logic': json['logic'],
        'fixLoadCapacity': json['fix_load_capacity'],
        'minLoadCapacity': json['min_load_capacity'],
        'minOrderQuantityOnce': json['min_order_quantity_once'],
        'todayTransportLotList': ((json['today_transportLotList'] as Array<any>).map(TransportLotInputFromJSON)),
        'nextdayTransportLotList': ((json['nextday_transportLotList'] as Array<any>).map(TransportLotInputFromJSON)),
        'todayStockList': ((json['today_stockList'] as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerFromJSON)),
        'nextdayStockList': ((json['nextday_stockList'] as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerFromJSON)),
    };
}

export function OptimizeTransportLotRequestToJSON(value?: OptimizeTransportLotRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'logic': value.logic,
        'fix_load_capacity': value.fixLoadCapacity,
        'min_load_capacity': value.minLoadCapacity,
        'min_order_quantity_once': value.minOrderQuantityOnce,
        'today_transportLotList': ((value.todayTransportLotList as Array<any>).map(TransportLotInputToJSON)),
        'nextday_transportLotList': ((value.nextdayTransportLotList as Array<any>).map(TransportLotInputToJSON)),
        'today_stockList': ((value.todayStockList as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerToJSON)),
        'nextday_stockList': ((value.nextdayStockList as Array<any>).map(OptimizeTransportLotRequestTodayStockListInnerToJSON)),
    };
}

